import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionService } from '../../providers/session.service';
import { UserService } from '../../providers/user.service';
import { PersonService } from '../../providers/person.service';
import { UsefPersonService } from '../../providers/usef-person.service';
import { EditPersonComponent } from '../people/edit-person/edit-person.component';
import { PaymentCustomerService } from '../../providers/payment-customer.service';
import { User } from '../../models/user';
import { Person } from '../../models/person';
import { Usef_person } from '../../models/usef/usef_person';
import { Braintree_customer } from '../../models/accounting/banking/braintree_customer';
import { Braintree_credit_card } from '../../models/accounting/banking/braintree_credit_card';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import { faSave, faTrash, faLink, faUnlink }  from '@fortawesome/fontawesome-pro-regular';
import { ModalConfirmDialogComponent } from '../modal-confirm-dialog/modal-confirm-dialog.component';
import { PaymentCardService } from 'src/app/providers/payment-card.service';

@Component({
  standalone: false,
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
styleUrls:  ['./my-account.component.css']
})
export class MyAccountComponent extends SmsAbstractAppPage implements OnInit {
  faSave = faSave;
  faTrash = faTrash;
  faLink = faLink;
  faUnlink = faUnlink;
  person: Person = new Person({});
  usef_person: Usef_person = new Usef_person({});
  user: User;
  password_match: string = "";
  change_password: boolean = false;
  customer_list: Braintree_customer[] = [];
  person_save_in_progress: boolean = false;

  private _userSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private sessionService: SessionService,
    private userService: UserService,
    private personService: PersonService,
    private usefPersonService: UsefPersonService,
    private paymentCustomerService: PaymentCustomerService,
    private paymentCardService: PaymentCardService,
    private modal: NgbModal) {
  	super();
  }

  ngOnInit() {
  	this._userSubscription = this.sessionService.user$.subscribe(user => {
  		this.user = user;
  		this.personService.get(user.user_person_id).then(person => {
  			this.person = person;
  			if(person.use_usef_personal_details && person.usef_person_uuid != ''){
  				this.usefPersonService.getByUuid(person.usef_person_uuid).then(usef_person => {
  					this.usef_person = usef_person;
  				}).catch(error => {
  					this.handleError(error);
  				});
  			}

  		}).catch(error => {
  			this.handleError(error);
  		});

      this.paymentCustomerService.get_list().then(customer_list => {
        this.customer_list = customer_list;
      }).catch(error => {
        this.handleError(error);
      });


  	}, error => {
  		this.handleError(error);
  	});

  }

  	onSubmitUserForm(){

	  	this.userService.update(this.user, this.change_password, this.password_match, "").then(user => {
	  		this.user = user;
	  		this.change_password = false;
	  		this.password_match = '';
	  		this.handleMessage("USER " + user.username + " SAVED!", "success");
		}).catch(error => {
			this.handleError(error);
		});
	 }

	 handleSavePerson(person: Person){
     this.person_save_in_progress = true;
	 	this.personService.update(person).then(updated_person => {
	 		this.person = updated_person;
	 		this.handleMessage(updated_person.first_name + " " + updated_person.last_name + " SAVED!", 'success');
       this.person_save_in_progress = false;
       document.getElementById('div-messages').scrollIntoView();
	 	}).catch(error =>{
       this.person_save_in_progress = false;
	 		this.handleError(error);
	 	});
	 }

   handleHideCustomer(customer: Braintree_customer){
     let modal_ref_confirm = this.modal.open(ModalConfirmDialogComponent, {size: 'sm'});
     modal_ref_confirm.componentInstance.title = 'HIDE ' + customer.first_name + " " + customer.last_name + "!";
     modal_ref_confirm.componentInstance.message = "Please confirm that you want to remove " + customer.first_name + " " + customer.last_name + " and all their associated payment cards from your account.";

     modal_ref_confirm.componentInstance.yes$.subscribe(response => {
       if(response){
         modal_ref_confirm.close();
         this.paymentCustomerService.hide(customer).then(response => {
           if(response){
             this.customer_list.forEach((ls_customer, i) => {
               if(ls_customer.system_customer_id == customer.system_customer_id){
                 this.customer_list.splice(i, 1);
               }
             });
           }
         }).catch(error => {
           this.handleError(error);
         });
       }
     }, error => {
       this.handleError(error);
       modal_ref_confirm.close();
     });

      modal_ref_confirm.componentInstance.no$.subscribe(response => {
       if(response){
         modal_ref_confirm.close();
       }
     }, error => {
       modal_ref_confirm.close();
     });

   }

   handleHideCard(card: Braintree_credit_card){

    let modal_ref_confirm = this.modal.open(ModalConfirmDialogComponent, {size: 'sm'});
    modal_ref_confirm.componentInstance.title = 'HIDE ' + card.masked_number + "!";
    modal_ref_confirm.componentInstance.message = "Please confirm that you want to remove " + card.masked_number +" from your account. Removing this card will not make it unavailable to the show organizer for any entries you have already submitted but will remove it from your account for future entries.";

    modal_ref_confirm.componentInstance.yes$.subscribe(response => {
      if(response){
        modal_ref_confirm.close();
        this.paymentCardService.hide(card).then(response => {
          if(response){
            this.customer_list.forEach((ls_customer, i) => {
              if(ls_customer.system_customer_id == card.system_customer_id){
                ls_customer.credit_card_list.forEach((ls_card, i) => {
                  if(ls_card.system_payment_method_id == card.system_payment_method_id){
                    ls_customer.credit_card_list.splice(i, 1);
                  }
                });
              }
            });
          }
        }).catch(error => {
          this.handleError(error);
        });
      }
    }, error => {
      this.handleError(error);
      modal_ref_confirm.close();
    });

     modal_ref_confirm.componentInstance.no$.subscribe(response => {
      if(response){
        modal_ref_confirm.close();
      }
    }, error => {
      modal_ref_confirm.close();
    });



   }

}
